import { useRouter } from 'next/router'

import { useAppDispatch } from '~/redux/hooks'
import { REWARD_FEATURE } from '~/gamification/types/gamification.types'
import { setIsNotificationListOpen } from '~/gamification/slices/gamification.slice'
import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'

export function useClickActions(itemKey: string): { handleClick: (event: React.MouseEvent<HTMLElement>) => void } {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const selectGradeUrl = useGetGradePageRoute()

  const handleClick = (): void => {
    switch (itemKey) {
      case REWARD_FEATURE.PICK_CURRICULUM:
        router.push(selectGradeUrl)
        break
    }

    dispatch(setIsNotificationListOpen(false))
  }

  return { handleClick }
}
